import React, { useMemo, useRef } from 'react';
import { useSetResolved } from '@wearejh/m2-pwa-engine/lib/router/useSetResolved';

import { RichText } from 'src/components/RichText/RichText';

import { Container, Wrapper } from '../Layout';

import { CmsLayoutOneColumn } from './CmsLayoutOneColumn';
import { CmsLayoutDefault } from './CmsLayoutDefault';
import { CmsLayoutSidebar } from './CmsLayoutSidebar';

export type CmsPageInnerProps = {
    title: string | null;
    content_heading: string | null;
    content: string;
    page_layout: string | CmsLayout;
};

export enum CmsLayout {
    OneColumn = '1column',
    TwoColumnsLeft = '2columns-left',
    TwoColumnsRight = '2columns-right',
}

export const CmsPageInner = React.memo(function CmsPageInner(props: CmsPageInnerProps) {
    const cmsRef = useRef<HTMLDivElement>(null);
    const isFullWidth = props.page_layout === 'cms-full-width';
    const isPageBuilder = props.content.includes('data-content-type');

    useSetResolved();

    const inner = useMemo(() => {
        switch (props.page_layout) {
            case CmsLayout.TwoColumnsRight:
            case CmsLayout.TwoColumnsLeft: {
                return <CmsLayoutSidebar {...props} />;
            }
            case CmsLayout.OneColumn: {
                return <CmsLayoutOneColumn {...props} />;
            }
            default: {
                return <CmsLayoutDefault {...props} />;
            }
        }
    }, [props]);

    if (isPageBuilder && props.content) {
        return <RichText content={props.content} />;
    }

    if (isFullWidth) {
        return (
            <Wrapper variant="page-inner">
                <div ref={cmsRef}>
                    {inner}
                </div>
            </Wrapper>
        );
    }

    return (
        <Wrapper variant="page-inner">
            <Container>
                <div ref={cmsRef}>
                    {inner}
                </div>
            </Container>
        </Wrapper>
    );
});
